<div class="reaction-pvt">
  <!-- INTRO / DEMO -->
  <ng-container *ngIf="phase === 'intro'">
    <div class="cog-spacer"></div>
    <div class="rp-demo-pill">{{ 'cognitive.sharpV2.reaction.demoTag' | translate }}</div>
    <div class="rp-eyebrow">{{ 'cognitive.sharpV2.reaction.eyebrow' | translate }}</div>
    <h2 class="cog-h2 rp-title">{{ 'cognitive.sharpV2.reaction.title' | translate }}</h2>
    <p class="cog-subtitle rp-intro">{{ 'cognitive.sharpV2.reaction.intro' | translate }}</p>

    <div class="rp-demo-dots">
      <div class="rp-demo-col">
        <div class="rp-demo-dot pink"></div>
        <div class="rp-demo-label">{{ 'cognitive.sharpV2.reaction.labelTap' | translate }}</div>
      </div>
      <div class="rp-demo-col">
        <div class="rp-demo-dot blue"></div>
        <div class="rp-demo-label">{{ 'cognitive.sharpV2.reaction.labelHold' | translate }}</div>
      </div>
    </div>

    <div class="cog-spacer"></div>
    <button type="button" class="cog-btn cog-btn-primary" (click)="startTask()">
      {{ 'cognitive.sharpV2.reaction.start' | translate }}
    </button>
  </ng-container>

  <!-- INTERRUPTED: the stimulus in flight is thrown away, not scored (brief 3.3) -->
  <ng-container *ngIf="phase === 'interrupted'">
    <div class="cog-spacer"></div>
    <div class="cog-text-center cog-mb-16">
      <h2 class="cog-h2">{{ 'cognitive.sharpV2.reaction.interruptedTitle' | translate }}</h2>
      <p class="cog-subtitle">{{ 'cognitive.sharpV2.reaction.interruptedBody' | translate }}</p>
    </div>
    <div class="cog-spacer"></div>
    <button type="button" class="cog-btn cog-btn-primary" (click)="resumeAfterInterrupt()">
      {{ 'cognitive.sharpV2.reaction.interruptedCta' | translate }}
    </button>
  </ng-container>

  <!-- TASK -->
  <ng-container *ngIf="phase === 'task' || phase === 'done'">
    <div class="rp-head">
      <div class="rp-task-title">{{ 'cognitive.sharpV2.reaction.taskTitle' | translate }}</div>
      <div class="rp-task-hint">{{ 'cognitive.sharpV2.reaction.taskHint' | translate }}</div>
    </div>

    <div class="rp-dots">
      <span *ngFor="let d of trialDots" class="rp-dot" [class.on]="d"></span>
    </div>

    <div
      class="rp-stim"
      (mousedown)="onTap($event)"
      (touchstart)="onTap($event)"
    >
      <div
        class="rp-circle"
        [class.pink]="dotState === 'pink'"
        [class.blue]="dotState === 'blue'"
        [class.tapped]="justTapped"
      ></div>
    </div>

    <div class="rp-foot">
      <div class="rp-counter">
        {{ 'cognitive.sharpV2.reaction.counter' | translate: counterParams }}
      </div>
      <div class="rp-wait" *ngIf="waiting">
        {{ 'cognitive.sharpV2.reaction.wait' | translate }}
      </div>
      <div class="rp-extend" *ngIf="extendMessage">
        {{ 'cognitive.sharpV2.reaction.extend' | translate }}
      </div>
    </div>
  </ng-container>
</div>
